"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var axios_1 = __importDefault(require("axios"));
var Box_1 = __importDefault(require("@mui/material/Box"));
var Link_1 = __importDefault(require("@mui/material/Link"));
var Typography_1 = __importDefault(require("@mui/material/Typography"));
var mountIsland_1 = require("../mountIsland");
function formatDate(dateString) {
    var _a;
    var date = new Date(dateString);
    var options = { year: 'numeric', month: 'long', day: 'numeric' };
    var lang = (_a = document.documentElement.getAttribute('lang')) !== null && _a !== void 0 ? _a : undefined;
    return date.toLocaleDateString(lang, options);
}
function GetInitiateArticles() {
    var _a, _b;
    var _c = (0, react_1.useState)([]), initiate_articles = _c[0], setInitiateArticles = _c[1];
    (0, react_1.useEffect)(function () {
        axios_1.default.get('/api/v2/students/initiate')
            .then(function (response) {
            setInitiateArticles(response.data.initiate.articles);
        })
            .catch(function (error) {
            console.log(error);
        });
    }, []);
    if (initiate_articles.length === 0) {
        return react_1.default.createElement(Box_1.default, null, "Loading...");
    }
    var alt_image = ((_b = (_a = document.getElementById('initiate_articles')) === null || _a === void 0 ? void 0 : _a.getAttribute('data-alt-image')) !== null && _b !== void 0 ? _b : '') +
        'images/logo_purple_medium.png';
    return (react_1.default.createElement(Box_1.default, { className: "container student-container initiate-container" },
        react_1.default.createElement(Box_1.default, { className: "article-grid" }, initiate_articles.map(function (article) {
            var _a;
            return (react_1.default.createElement(Box_1.default, { key: article.ID, className: "article-grid-key" },
                react_1.default.createElement(Link_1.default, { href: article.guid, underline: "hover" },
                    react_1.default.createElement(Box_1.default, { component: "img", src: ((_a = article.image_url) !== null && _a !== void 0 ? _a : '').replace('www.msia.org', 'cdn.msia.org'), alt: article.post_title, className: "article-image", onError: function (event) {
                            event.currentTarget.src = alt_image;
                            event.currentTarget.onerror = null;
                        } })),
                react_1.default.createElement(Typography_1.default, { variant: "body2", component: "h5" }, formatDate(article.post_date)),
                react_1.default.createElement(Link_1.default, { href: article.guid, underline: "hover" },
                    react_1.default.createElement(Typography_1.default, { variant: "body2", component: "h5" }, article.post_title))));
        }))));
}
exports.default = GetInitiateArticles;
var initiateArticlesContainer = document.getElementById('initiate_articles');
if (initiateArticlesContainer) {
    (0, mountIsland_1.mountIsland)(initiateArticlesContainer, react_1.default.createElement(GetInitiateArticles, null));
}
